import { PositionType } from '@annunciate/core';
import { getProgressTime } from './getPositionTime';
export const getProgressPercent = (progress) => {
    const position = progress?.position;
    switch (position?.type) {
        case PositionType.EBOOK:
            const { location } = position;
            if (location) {
                return location?.locations?.totalProgression || 0;
            }
            else {
                return 0;
            }
        case PositionType.TIME:
            const { unit } = position;
            if (progress.duration) {
                return getProgressTime(progress, unit) / progress.duration.length;
            }
            else {
                return getProgressTime(progress, unit);
            }
        case PositionType.COMPLETED:
            return 1;
        default:
            return 0;
    }
};
//# sourceMappingURL=getProgressPercent.js.map